// extracted by mini-css-extract-plugin
export default {"loaderComponent_wrapper":"loaderComponent_wrapper___AT3oz","loaderComponent_icon":"loaderComponent_icon___lEstN","spin":"spin___ij_y8"};